// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"5fbbb8ba","351":"8e4ea13f","661":"433dbc55"}[chunkId] + ".chunk.js";
};